export const environment = {
  production: true,
  buildId: '3732734967223251',
  configFile: 'config.json',
};
